<template>
    <div style="width: 100%; height: 100%; background-color: black;" ref="meter"></div>
</template>

<script>
import PeakDisplay from './PeakDisplayDb';
import PeakProgrammeMeter from "./PeakProgrammeMeter";

const AudioContext = window.AudioContext || window.webkitAudioContext;

export default {
    props: {
        mediaStream: {
            type: MediaStream,
        },

        audioContext: {
            type: AudioContext
        },
    },

    watch: {
        mediaStream() {
            this.ppm.updateMediaStream(this.mediaStream);
        },
    },

    methods: {},

    beforeMount() {
        this.ppm = new PeakProgrammeMeter({
            audioContext: this.audioContext,
            mediaStream: this.mediaStream,
            windowSizeMs: 80,
        });

        this.ppm.on("tick", (peaks) => {
            if (this.peakDisplay) this.peakDisplay.update(peaks, this.ppm.windowSizeMs);
        });
    },

    async mounted() {
        this.peakDisplay = new PeakDisplay(this.$refs.meter, true, false);
    },

    beforeDestroy() {
        this.peakDisplay.destroy();
        this.peakDisplay = null;
        this.ppm.destroy();
        this.ppm = null;
    }
};
</script>